module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/primary-hover.98508b47.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/primary-hover.png
// module id = 3065
// module chunks = 11